// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__zmN-6","footer":"ModalCreateQualiphyProcedure_footer__27Mug","additionData":"ModalCreateQualiphyProcedure_additionData__wGbhL"};